import React, { useMemo } from 'react'
import Text from 'particles/Text'
import { useNewTranslation } from 'hooks/index'
import { ReadOnlyContainer } from './style'

interface NoValueProps {
    context?: string
    minHeight?: string
    flexAlign?: string
    isSelector?: boolean
}

const NoValue: React.FC<NoValueProps> = ({ context, minHeight, isSelector = false }) => {
    const [newT] = useNewTranslation()

    const displayText = useMemo(() => {
        if (context) {
            return context
        }
        if (isSelector) {
            return newT('placeholderText.noItemSelected', 'No item selected')
        } else {
            return newT('placeholderText.noDetailsAdded', 'No details added.')
        }
    }, [context, isSelector])
    return (
        <ReadOnlyContainer minHeight={minHeight} flexAlign="center">
            <Text color="placeholder">{displayText}</Text>
        </ReadOnlyContainer>
    )
}
export default NoValue
